export default __webpack_public_path__ + "static/media/test1.9dbd38b6.svg";